import { render, staticRenderFns } from "./PaymentMethodsList.vue?vue&type=template&id=70936cd5&scoped=true&"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsList.vue?vue&type=style&index=0&id=70936cd5&lang=scss&scoped=true&"
import style1 from "./PaymentMethodsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70936cd5",
  null
  
)

export default component.exports